
import React, { useEffect, useState } from 'react';

const TopHeader = () => {
    const [showFraudContent, setShowFraudContent] = useState(true);

    return (
        <>
            {
                showFraudContent
                &&
                <div className='fraud-warning-container'>
                    <div className="container ">
                        <div className="row-alt"></div>
                        <div className="row-alt">
                            <div className="fraud-warning">Impersonation Fraud Warning</div>
                            <div className="fraud-padding-bottom"></div>
                            <div className="fraud-content">Scammers are impersonating UOB Kay Hian entities in Malaysia on social media and messaging apps for fraudulent purposes. Please take note that UOB Kay Hian does not offer personal loans or investment opportunities with guaranteed high profits. Please be cautious of the such scam tactics. Contact your nearest known UOB Kay Hian office for verification if unsure. If you have already submitted your personal documents or paid them money, please report to the Securities Commission and PDRM without delay. You may find useful contacts and links in our <a href="https://www.utrade.com.my/public/banner_content/banner_id_383">Scam Alert</a> resource page of our UTRADE website.</div>
                        </div>
                        <div className="row-alt"><button className="asText" onClick={()=>setShowFraudContent(false)}>Close</button></div>
                    </div>
                </div>
            }
           
            <div className="top-line">
                <div className="top-header">
                 
                    <div className="container" style={{width:'100%'}}>
                        <div className="row">
                            <div className="col-12">
                            
                            </div>
                        </div>
                        <div className="row">
                            
                            <div className="col-md-5 col-sm-12">
                                <ul className="info">
                                    <li>
                                        <i
                                            className="fa fa-volume-control-phone"
                                            aria-hidden="true"
                                        ></i>
                                        <a href="tel:603-2147-1888">
                                            +603 2147 1888{' '}
                                        </a>
                                    </li>
                                    <li style={{marginLeft: '5px'}}>
                                        <i
                                            className="fa fa-envelope"
                                            aria-hidden="true"
                                        ></i>
                                        <a href="mailto:mycustomerservice@uobkayhian.com">
                                            mycustomerservice@uobkayhian.com{' '}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-7 col-sm-6">
                                <nav id="nav">
                                    <ul id="navigation2">
                                        <li>
                                            <a href="#">
                                                You are in{' '}
                                                <b>UTRADE MALAYSIA</b>{' '}
                                                <i
                                                    className="fa fa-caret-down"
                                                    aria-hidden="true"
                                                ></i>
                                            </a>
                                            <ul>
                                                <li>
                                                    <a
                                                        href="http://www.utrade.com.hk/"
                                                    >
                                                        UTRADE HONG KONG
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="http://www.utrade.co.id/  "
                                                    >
                                                        UTRADE INDONESIA
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="http://www.utrade.com.sg/"
                                                    >
                                                        UTRADE SINGAPORE
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="https://www.utrade.co.th/"
                                                    >
                                                        UTRADE THAILAND
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <ul id="navigation">
                                        <li>
                                            <a href="/login">
                                                Login
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://cob.utrade.com.my/openaccount">
                                                Open An Account
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopHeader;
